// MARKO DAMIAN — theme.js

document.addEventListener('DOMContentLoaded', function () {

  // ── LANDING ENTER ──
  const landing = document.getElementById('landing');
  const enterBtn = document.getElementById('enter-btn');

  if (landing && enterBtn) {
    // Only show landing on the homepage
    if (window.location.pathname === '/' || window.location.pathname === '') {
      // Check if user already entered this session
      if (sessionStorage.getItem('md-entered')) {
        landing.classList.add('hidden');
        document.body.classList.add('page-shop');
      }

      enterBtn.addEventListener('click', function () {
        landing.classList.add('hidden');
        document.body.classList.add('page-shop');
        sessionStorage.setItem('md-entered', '1');
      });
    } else {
      landing.classList.add('hidden');
      document.body.classList.add('page-shop');
    }
  } else {
    document.body.classList.add('page-shop');
  }

  // ── SIZE SELECTOR ──
  const sizeBtns = document.querySelectorAll('.size-btn');
  const variantInput = document.getElementById('variant-id');

  sizeBtns.forEach(function (btn) {
    btn.addEventListener('click', function () {
      sizeBtns.forEach(function (b) { b.classList.remove('selected'); });
      btn.classList.add('selected');
      if (variantInput) {
        variantInput.value = btn.dataset.variantId || '';
      }
    });
  });

  // ── CART COUNT UPDATE ──
  updateCartCount();

  function updateCartCount() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        const badge = document.querySelector('.cart-count');
        if (badge) {
          if (cart.item_count > 0) {
            badge.textContent = cart.item_count;
            badge.classList.add('visible');
          } else {
            badge.classList.remove('visible');
          }
        }
      })
      .catch(function () {});
  }

  // ── ADD TO CART ──
  const atcForm = document.getElementById('atc-form');
  if (atcForm) {
    atcForm.addEventListener('submit', function (e) {
      e.preventDefault();
      const formData = new FormData(atcForm);
      const btn = atcForm.querySelector('.btn-atc');
      const original = btn.textContent;

      fetch('/cart/add.js', {
        method: 'POST',
        body: formData
      })
        .then(function (r) { return r.json(); })
        .then(function () {
          btn.textContent = 'Added';
          updateCartCount();
          setTimeout(function () { btn.textContent = original; }, 2000);
        })
        .catch(function () {
          btn.textContent = 'Error — try again';
          setTimeout(function () { btn.textContent = original; }, 2000);
        });
    });
  }

});
